const TOKEN_KEY = 'spin_lite_token';

export const authService = {
    // Sauvegarder le token
    setToken: (token) => {
        localStorage.setItem('token', token);
    },

    // Récupérer le token
    getToken: () => {
        return localStorage.getItem('token');
    },

    // Supprimer le token
    removeToken: () => {
        localStorage.removeItem('token');
    },

    // Vérifier si l'utilisateur est authentifié
    isAuthenticated: () => {
        const token = localStorage.getItem('token');
        return !!token;
    },

    // Décoder le token JWT
    decodeToken: (token) => {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            return JSON.parse(jsonPayload);
        } catch (error) {
            console.error('Erreur lors du décodage du token:', error);
            return null;
        }
    },

    // Récupérer le numéro de badge depuis le token
    getBadgeNumber: () => {
        return localStorage.getItem('badgeNumber');
    },

    // Vérifier et nettoyer le token
    checkAndCleanToken: () => {
        const token = localStorage.getItem('token');
        if (!token) {
            return false;
        }
        return true;
    },

    setBadgeNumber: (badgeNumber) => {
        localStorage.setItem('badgeNumber', badgeNumber);
    },

    removeBadgeNumber: () => {
        localStorage.removeItem('badgeNumber');
    }
}; 